import { render, staticRenderFns } from "./CategoryProductCreateUpdate.vue?vue&type=template&id=a529bd6c&"
import script from "./CategoryProductCreateUpdate.vue?vue&type=script&lang=js&"
export * from "./CategoryProductCreateUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports